// Shared visual primitives for the Fittin retailer dashboard.
// Black & white, glassmorphism, soft borders, very low chrome.

export function Card({ children, className = "", testid }) {
  return (
    <div
      data-testid={testid}
      className={`rounded-2xl border border-black/10 bg-white/70 backdrop-blur-md ${className}`}
      style={{ boxShadow: "0 1px 0 rgba(10,10,10,0.02), 0 8px 32px -16px rgba(10,10,10,0.06)" }}
    >
      {children}
    </div>
  );
}

export function CardHeader({ eyebrow, title, action }) {
  return (
    <div className="flex items-start justify-between gap-4 px-6 pt-6 pb-3">
      <div>
        {eyebrow && (
          <div className="text-[10px] uppercase tracking-[0.22em] text-neutral-500">
            {eyebrow}
          </div>
        )}
        {title && (
          <div className="mt-1 text-[15px] font-medium tracking-tight text-[#0A0A0A]">
            {title}
          </div>
        )}
      </div>
      {action}
    </div>
  );
}

export function KpiCard({ label, value, hint, testid, trend }) {
  return (
    <Card testid={testid} className="p-6">
      <div className="text-[10px] uppercase tracking-[0.22em] text-neutral-500">
        {label}
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <div className="text-4xl tracking-[-0.035em] font-medium text-[#0A0A0A]">
          {value}
        </div>
        {trend && (
          <div
            className={`text-[11px] font-mono ${
              trend.startsWith("+") ? "text-emerald-700" : "text-neutral-500"
            }`}
          >
            {trend}
          </div>
        )}
      </div>
      {hint && (
        <div className="mt-2 text-[12px] text-neutral-500">{hint}</div>
      )}
    </Card>
  );
}

export function Pill({ tone = "neutral", children }) {
  const tones = {
    neutral: "bg-neutral-100 text-neutral-700",
    low: "bg-emerald-50 text-emerald-700 border border-emerald-100",
    medium: "bg-amber-50 text-amber-700 border border-amber-100",
    high: "bg-red-50 text-red-700 border border-red-100",
    dark: "bg-[#0A0A0A] text-white",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] tracking-tight ${
        tones[tone] || tones.neutral
      }`}
    >
      {children}
    </span>
  );
}

export function SectionTitle({ children, hint, action }) {
  return (
    <div className="flex items-end justify-between gap-4 mt-12 mb-5">
      <div>
        <div className="text-[10px] uppercase tracking-[0.22em] text-neutral-500">
          Section
        </div>
        <h2 className="mt-1 text-2xl tracking-[-0.025em] font-medium">{children}</h2>
        {hint && (
          <div className="mt-1 text-[13px] text-neutral-500 max-w-md">{hint}</div>
        )}
      </div>
      {action}
    </div>
  );
}
